import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import BrightnessGraph from '../profiles/BrightnessGraph';

const DeviceSelectSideBar = ({ t, event, schedule }) => (
  <div>
    <h1>{t('EVENT')}: {event.description}</h1>
    <h2>{t('SCHEDULE')}: {schedule.description}</h2>
    <div className="profile-chart">
      <div className="chart-container">
        <BrightnessGraph brightness={schedule.settings || []} />
      </div>
    </div>
  </div>
)

export default translate('profile')(connect(
  ( { events }, { eventId, scheduleId } ) => {
    const event = events.data.find(e => e.id === eventId);
    return {
      event,
      schedule: event.schedules.find(s => s.id === scheduleId) // probably should have it's own state
    }
  }
)(DeviceSelectSideBar))



// WEBPACK FOOTER //
// ./src/components/schedules/DeviceSelectSideBar.js